<template>
  <section class="diy-card-catalogue__section">
    <!-- CATEGORY -->
    <div class="diy-card-catalogue__section-heading">
      <CardCategory :category="cards[0].category" />
    </div>
    <!-- SECTION LISTING -->
    <div class="diy-card-catalogue__section-listing">
      <CardCatalogueCard v-for="card in cards" :key="card.card_id" :card="card" />
    </div>
  </section>
</template>

<script>
// Components
import CardCategory from 'Components/CardCategory'
import CardCatalogueCard from './CardCatalogueCard'

export default {
  name: 'CardCatalogueSection',

  components: {
    CardCategory,
    CardCatalogueCard,
  },

  props: {
    cards: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.diy-card-catalogue__section-heading {
  text-align: center;
  margin-bottom: 30px;
}

.diy-card-catalogue__section-heading .card-category {
  display: inline-block;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 1px;
  padding: 5px 8px;
}

.diy-card-catalogue__section-listing .diy-card-catalogue__card:not(:first-of-type) {
  margin-top: 10px;
}
</style>
